import { BrowserRouter } from "react-router-dom";
import { useState } from "react";
// ** Material theme
import { Box, ThemeProvider, Divider } from "@mui/material";
import { CssBaseline } from "@mui/material";
import theme from "./theme/theme";
import "./App.css";
// ** Custom Components
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Content from "./components/Content";
import Content1 from "./components/Content1";
import Quote from "./components/Quote";
import Content2 from "./components/Content2";
import Content3 from "./components/Content3";
import Services from "./components/Services";
import Goals from "./components/Goals";
import Target from "./components/Target";
import NavBar from "./components/NavBar";

const App = () => {
  const [customTheme, setCustomTheme] = useState(theme);

  return (
    <BrowserRouter>
      <ThemeProvider theme={customTheme}>
        <CssBaseline />
        <div className="app">
          <NavBar />
          <Content />
          <Content3 />
          <Quote />
          <Content2 />
          <Target />
          <Divider />
          <Content1 />
          <Goals />
          <Divider />

          <Footer />
          <WhatsAppButton />
        </div>
      </ThemeProvider>
    </BrowserRouter>
  );
};
export default App;
